module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gb-Hc-Ic.fb9ceb74.png";